import React, { useEffect, useState, useRef } from 'react';
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Spinner,
  Table,
} from 'react-bootstrap';
import apinode from '../../services/apinode';
import 'bootstrap/dist/css/bootstrap.min.css';

const coordenadasEstados = {
  SP: { lat: -23.5505, lng: -46.6333 },
  RJ: { lat: -22.9068, lng: -43.1729 },
  MG: { lat: -19.9167, lng: -43.9345 },
  PR: { lat: -25.4284, lng: -49.2733 },
  BA: { lat: -12.9718, lng: -38.5011 },
  GO: { lat: -16.6869, lng: -49.2648 },
  CE: { lat: -3.7172, lng: -38.5433 },
  RS: { lat: -30.0346, lng: -51.2177 },
  PE: { lat: -8.0476, lng: -34.877 },
  SC: { lat: -27.5954, lng: -48.548 },
  DF: { lat: -15.7797, lng: -47.9297 },
  AM: { lat: -3.4168, lng: -65.8561 },
  PA: { lat: -1.455, lng: -48.503 },
  MT: { lat: -12.6819, lng: -56.9211 },
  MS: { lat: -20.4697, lng: -54.6201 },
  ES: { lat: -20.3155, lng: -40.3128 },
  MA: { lat: -2.5387, lng: -44.2825 },
  PB: { lat: -7.115, lng: -34.8631 },
  RN: { lat: -5.7945, lng: -35.211 },
  RO: { lat: -11.5057, lng: -63.5806 },
  AL: { lat: -9.5713, lng: -36.782 },
  PI: { lat: -5.0892, lng: -42.8016 },
  SE: { lat: -10.9472, lng: -37.0731 },
  TO: { lat: -10.25, lng: -48.25 },
  AP: { lat: 1.373, lng: -51.887 },
  RR: { lat: 2.8235, lng: -60.6753 },
  AC: { lat: -9.97499, lng: -67.8243 },
};

const DashboardVendasRegiao = () => {
  const [dadosVendas, setDadosVendas] = useState([]);
  const [filtroEstado, setFiltroEstado] = useState('');
  const [dataInicio, setDataInicio] = useState('');
  const [dataFim, setDataFim] = useState('');
  const [carregando, setCarregando] = useState(false);
  const mapaRef = useRef(null);

  const carregarDados = async () => {
    setCarregando(true);
    try {
      const response = await apinode.get(`/estados/vendas/${localStorage.idconta}`, {
        params: {
          inicio: dataInicio,
          fim: dataFim,
        },
      });

      const dados = response.data;
      const dadosComCoords = dados.filter((item) => coordenadasEstados[item.estado]);
      setDadosVendas(dadosComCoords);
    } catch (error) {
      console.error('Erro ao buscar dados da API:', error);
    } finally {
      setCarregando(false);
    }
  };

  useEffect(() => {
    if (dataInicio && dataFim) {
      carregarDados();
    }
  }, [dataInicio, dataFim]);

  useEffect(() => {
    if (!carregando && window.google && mapaRef.current) {
      const map = new window.google.maps.Map(mapaRef.current, {
        zoom: 4,
        center: { lat: -15, lng: -55 },
        mapTypeId: 'roadmap',
      });

      const pontos = dadosVendas
        .map((v) => {
          const coords = coordenadasEstados[v.estado];
          if (!coords) return null;
          return {
            location: new window.google.maps.LatLng(coords.lat, coords.lng),
            weight: v.receita,
          };
        })
        .filter(Boolean);

      new window.google.maps.visualization.HeatmapLayer({
        data: pontos,
        map: map,
        radius: 40,
      });
    }
  }, [carregando, dadosVendas]);

  const vendasFiltradas = filtroEstado
    ? dadosVendas.filter((v) => v.estado === filtroEstado)
    : dadosVendas;

  const vendasOrdenadas = [...vendasFiltradas].sort((a, b) => b.receita - a.receita);
  const totalReceita = vendasOrdenadas.reduce((soma, v) => soma + v.receita, 0);

  return (
    <Container className="py-4">
      <h2 className="mb-4">📊 Dashboard de Vendas por Estado</h2>

      <Row className="mb-3">
        <Col md={3}>
          <Form.Label>Data Início</Form.Label>
          <Form.Control
            type="date"
            value={dataInicio}
            onChange={(e) => setDataInicio(e.target.value)}
          />
        </Col>
        <Col md={3}>
          <Form.Label>Data Fim</Form.Label>
          <Form.Control
            type="date"
            value={dataFim}
            onChange={(e) => setDataFim(e.target.value)}
          />
        </Col>
        <Col md={6}>
          <Form.Label>Filtrar por Estado</Form.Label>
          <Form.Select
            value={filtroEstado}
            onChange={(e) => setFiltroEstado(e.target.value)}
          >
            <option value="">Todos os Estados</option>
            {dadosVendas.map((v) => (
              <option key={v.estado} value={v.estado}>
                {v.estado}
              </option>
            ))}
          </Form.Select>
        </Col>
      </Row>

      {carregando ? (
        <div className="text-center">
          <Spinner animation="border" />
          <p>Carregando dados...</p>
        </div>
      ) : (
        <Row>
          <Col md={6}>
            <Card className="mb-3">
              <Card.Body>
                <Card.Title>💰 Receita (Filtrada)</Card.Title>
                <Table striped bordered hover responsive>
                  <thead>
                    <tr>
                      <th>Estado</th>
                      <th>Receita</th>
                    </tr>
                  </thead>
                  <tbody>
                    {vendasOrdenadas.map((venda) => (
                      <tr key={venda.estado}>
                        <td>{venda.estado}</td>
                        <td>
                          R$ {venda.receita.toLocaleString('pt-BR', {
                            minimumFractionDigits: 2,
                          })}
                        </td>
                      </tr>
                    ))}
                    <tr style={{ fontWeight: 'bold' }}>
                      <td>Total</td>
                      <td>
                        R$ {totalReceita.toLocaleString('pt-BR', {
                          minimumFractionDigits: 2,
                        })}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </Col>

          <Col md={6}>
            <Card className="mb-3">
              <Card.Body>
                <Card.Title>🌎 Mapa de Calor</Card.Title>
                <div
                  ref={mapaRef}
                  style={{ width: '100%', height: '300px' }}
                />
              </Card.Body>
            </Card>
          </Col>
        </Row>
      )}
    </Container>
  );
};

export default DashboardVendasRegiao;
